import type { ReactNode } from "react";
import { HoverInfo } from "../basic/Tooltip";
import { css } from "../../../../styled-system/css";

interface Props<T extends ReactNode> {
  name: string;
  value: T;
  formatter?: (d: T) => ReactNode;
  target?: T;
  showTarget?: boolean;
  showTargetLabel?: boolean;
  targetLabel?: string;
  targetColor?: string;
  targetFormatter?: (d: T) => React.ReactNode;
  toolTip?: string | null;
  center?: boolean;
}

const defaultFormatter = <T,>(v: T) => v;

const DetailedMetric = <T extends ReactNode>({
  name,
  value,
  formatter,
  target,
  showTarget = false,
  showTargetLabel,
  targetLabel = "vs. target",
  targetColor,
  targetFormatter,
  toolTip = null,
  center = false,
}: Props<T>) => {
  const format = formatter || defaultFormatter;
  const formatTarget = targetFormatter || format;

  return (
    <div>
      <div
        className={css({
          textAlign: { base: "center", md: center ? "center" : "end" },
        })}
      >
        <span
          className={css({
            display: "flex",
            gap: "xsmall",
            justifyContent: { base: "center", md: center ? "center" : "end" },
            alignItems: "center",
            color: "text.label",
            fontSize: "large",
            fontWeight: 500,
            lineHeight: "1",
          })}
        >
          {name}
          {toolTip && <HoverInfo iconClassName={css({ color: "grey", fontSize: "small" })}>{toolTip}</HoverInfo>}
        </span>
      </div>
      <div
        className={css({
          textAlign: { base: "center", md: center ? "center" : "end" },
        })}
      >
        <h3
          className={css({
            marginTop: "0.2rem",
            marginBottom: "0.2rem",
            fontSize: "xxlarge",
            fontWeight: "600",
          })}
        >
          {format(value)}
        </h3>
        <div className={css({ minHeight: "20px" })}>
          <small>
            {showTarget ?
              <>
                {showTargetLabel && <>{targetLabel} </>}
                <span className={css({ color: targetColor, fontWeight: "bold" })}>{formatTarget(target!)}</span>
              </>
            : " "}
          </small>
        </div>
      </div>
    </div>
  );
};

export default DetailedMetric;
